import { Badge } from '@/components/ui/badge';

const MAP = {
  draft: { label: 'Borrador', cls: 'bg-[rgba(169,180,208,0.12)] text-[#cbd5ff] border-[rgba(169,180,208,0.25)]' },
  sent: { label: 'Enviado', cls: 'bg-[rgba(76,201,240,0.12)] text-[#BDEFFF] border-[rgba(76,201,240,0.30)]' },
  accepted: { label: 'Aceptado', cls: 'bg-[rgba(47,230,166,0.12)] text-[#BFF7E6] border-[rgba(47,230,166,0.30)]' },
  rejected: { label: 'Rechazado', cls: 'bg-[rgba(255,92,122,0.12)] text-[#FFD0DA] border-[rgba(255,92,122,0.30)]' },
  expired: { label: 'Vencido', cls: 'bg-[rgba(246,193,119,0.12)] text-[#FFE2B8] border-[rgba(246,193,119,0.30)]' },
};

export function QuoteStatusBadge({ status = 'draft', expired = false }) {
  const key = expired ? 'expired' : status;
  const m = MAP[key] || MAP.draft;
  return (
    <Badge
      variant="outline"
      data-testid="quote-status-badge"
      className={`${m.cls} px-2.5 py-0.5 text-xs font-medium`}
    >
      {m.label}
    </Badge>
  );
}
